'use strict';
const angular = require('angular');
import {UtilService} from './util.service';

export default angular.module('nodeApp.util', [])
  .factory('Util', UtilService)
  .name;



// WEBPACK FOOTER //
// ./client/components/util/util.module.ts